<div class="wrapper">
  <header>
    <mat-toolbar color="primary" fxLayout="row">
      <span fxFlex>Flight Leg Record</span>
      <span fxFlex fxLayoutAlign="end">
        <button
          mat-icon-button
          (click)="dialogRef.close()"
          title="Close Dialog"
        >
          <mat-icon>close</mat-icon>
        </button>
      </span>
    </mat-toolbar>
  </header>
  <div class="content content-height">
    <form [formGroup]="takeoff" (ngSubmit)="flight_leg_take_off()">
      <div fxLayout="column" fxLayout.gt-sm="row">
        <span
          fxFlex
          fxFlexAlign="center"
          fxLayout.sm="column"
          fxLayout.xs="column"
        >
          <span class="mat-input-wrapper">
            <mat-form-field>
              <airport-select formControlName="airport"> </airport-select>
            </mat-form-field>
          </span>
        </span>
        <span fxFlex fxFlexAlign="center" fxLayout.sm="row" fxLayout.xs="row">
          <span class="mat-input-wrapper">
            <mat-form-field style="width: 5em">
              <input
                matInput
                placeholder="Amount of Fuel"
                type="text"
                formControlName="amount_of_fuel"
                required
              />
            </mat-form-field>
            <mat-form-field style="width: 5em">
              <mat-select formControlName="fuel_unit">
                <mat-option value="%" default>%</mat-option>
                <mat-option value="g">Gallons</mat-option>
                <mat-option value="l">Liters</mat-option>
              </mat-select>
            </mat-form-field>
          </span>
        </span>
      </div>

      <div fxLayout="column" fxLayout.gt-sm="row">
        <span
          fxFlex
          fxFlexAlign="center"
          fxLayout.sm="column"
          fxLayout.xs="column"
          fxLayoutGap="5px"
        >
          <span class="mat-input-wrapper">
            <mat-form-field>
              <mat-placeholder>Engine Start Time</mat-placeholder>
              <mat-datetimepicker-toggle [for]="datetimePicker" matSuffix>
              </mat-datetimepicker-toggle>
              <mat-datetimepicker
                #datetimePicker
                type="datetime"
                openOnFocus="true"
                timeInterval="1"
              >
              </mat-datetimepicker>
              <input
                matInput
                formControlName="engine_start_time"
                [matDatetimepicker]="datetimePicker"
                autocomplete="false"
                required
              />
            </mat-form-field>
            <mat-error *ngIf="form_errors.engine_start_time">
              {{ form_errors.engine_start_time }}
            </mat-error>
          </span>
        </span>

        <span
          fxFlex
          fxFlexAlign="center"
          fxLayout.sm="column"
          fxLayout.xs="column"
        >
          <span class="mat-input-wrapper">
            <mat-form-field>
              <mat-placeholder> Wheel-Up Time </mat-placeholder>
              <mat-datetimepicker-toggle [for]="datetimePicker2" matSuffix>
              </mat-datetimepicker-toggle>
              <mat-datetimepicker
                #datetimePicker2
                type="datetime"
                openOnFocus="true"
                timeInterval="1"
              >
              </mat-datetimepicker>
              <input
                matInput
                formControlName="wheel_up_time"
                [matDatetimepicker]="datetimePicker2"
                autocomplete="false"
                required
              />
            </mat-form-field>
            <mat-error *ngIf="form_errors.wheel_up_time">
              {{ form_errors.wheel_up_time }}
            </mat-error>
          </span>
        </span>
      </div>

      <div fxLayout="column">
        <mat-form-field [hidden]="!show_note">
          <mat-placeholder> Note </mat-placeholder>
          <textarea matInput formControlName="note"></textarea>
        </mat-form-field>
      </div>

      <div *ngIf="form_errors.non_field_errors">
        <mat-error *ngFor="let error of form_errors.non_field_errors">
          {{ error }}
        </mat-error>
      </div>

      <div fxLayout="row" class="mt-2">
        <span fxFlex>
          <button
            mat-icon-button
            (click)="show_note = !show_note"
            type="button"
          >
            <mat-icon>note</mat-icon>
          </button>
        </span>

        <span fxFlex fxLayoutAlign="center" fxLayoutAlign.gt-sm="end">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="!takeoff.valid"
          >
            Submit
          </button>
        </span>
      </div>
    </form>
  </div>
</div>
